import { ReactNode } from 'react'

type ItemDetailsModalValueProps = { label: string; value: ReactNode }

const ItemDetailsModalValue = ({ label, value }: ItemDetailsModalValueProps) => {
  return (
    <div className="typography-body-l flex flex-1 flex-col gap-2 text-neutral-800 whitespace-pre-wrap">
      <p>{label}</p>
      <p className="border-l border-l-neutral-800 pl-2 font-bold min-h-[24px]">{value}</p>
    </div>
  )
}

export default ItemDetailsModalValue
